<template>
  <BottomSheet :show="show" @close="$emit('close')">
    <div class="px-6 pt-2 pb-4">
      <h2 class="text-2xl font-bold text-center mb-1">Seleziona un profilo</h2>
      <p class="text-gray-500 text-center mb-4">Scegli quale profilo utilizzare per continuare</p>
      <div>
        <div
          v-for="(profile, idx) in profiles"
          :key="profile.id"
          :class="[
            'flex items-center gap-3 p-2 mb-1 rounded-lg cursor-pointer transition border',
            idx === selectedProfileIndex
              ? 'bg-primary bg-opacity-10 border-primary ring-2 ring-primary'
              : 'hover:bg-gray-100 border-transparent'
          ]"
          @click="selectProfileIndex(idx)"
        >
          <img
            :src="getProfilePicture(profile.profilePictureUrl)"
            alt="Profile"
            class="w-10 h-10 rounded-full object-cover border border-gray-200"
          />
          <div class="flex flex-col items-start">
            <div class="font-medium text-base leading-tight">{{ profile.Name }}</div>
            <div class="text-xs text-gray-500 leading-tight">Cod. {{ profile.id }}</div>
          </div>
          <div v-if="idx === selectedProfileIndex" class="ml-auto text-primary">
            <i class="bx bx-check-circle text-2xl"></i>
          </div>
        </div>
      </div>
      <div class="flex gap-3 mt-6">
        <CuButton dark class="flex-1" @click="$emit('close')">Annulla</CuButton>
        <CuButton primary class="flex-1" :disabled="!profiles || profiles.length === 0" @click="continueWithSelected">Continua</CuButton>
      </div>
    </div>
  </BottomSheet>
</template>

<script>
import BottomSheet from './BottomSheet.vue'
import CuButton from '../cu/CuButton.vue'

export default {
  name: "ProfileSelectSheet",
  components: { BottomSheet, CuButton },
  props: {
    show: { type: Boolean, required: true },
    profiles: { type: Array, required: true }
  },
  data() {
    return {
      selectedProfileIndex: 0
    }
  },
  watch: {
    profiles: {
      immediate: true,
      handler(newVal) {
        if (Array.isArray(newVal) && newVal.length > 0) {
          this.selectedProfileIndex = 0;
        }
      }
    }
  },
  methods: {
    selectProfileIndex(idx) {
      this.selectedProfileIndex = idx;
    },
    continueWithSelected() {
      if (this.profiles && this.profiles[this.selectedProfileIndex]) {
        this.$emit('select', this.profiles[this.selectedProfileIndex]);
      }
    },
    getProfilePicture(url) {
      // Always prepend the API base URL
      if (url) {
        return 'https://api.castingup.it/' + url.replace(/^\/?/, '');
      }
      return '';
    }
  }
}
</script>
